module.exports = __webpack_public_path__ + "static/media/SarahSwitek_02_HowAreYouFeeling_3.651c9c94.mp3";